import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
	getDensityUnit,
	getVolumeUnit,
	getWeightUnit,
} from '../../../../constants'
import { getProductBySystemName } from '../../../../services/manageBookingService'
import './index.scss'
import {
	clearItemFromSessionStorage, getBase64Decoded, getFromSessionStorage, setToSessionStorage, getBase64Encoded
} from '../../../../utils/StorageUtils'
import WeightDetails from '../WeightDetails'
import { useSelector } from "react-redux";
const CargoDetails = ({ bookingDetails }) => {
	//for multilingual
	const [t] = useTranslation(['labels', 'errors'])

	const [cargoDetails, setCargoDetails] = useState([])
	const [productName, setProductName] = useState('')
	const dgCheckNormal = getFromSessionStorage('ifDg')

	const masterData = useSelector(state => state?.masterData);

	useEffect(() => {

		if (bookingDetails && bookingDetails.bookingCargoDetails) {
			setCargoDetails(bookingDetails.bookingCargoDetails)
		}
		; (async () => {
			try {
				let product = await getProductBySystemName(
					bookingDetails.bookingCargoDetails.product
				)
				if (product) {
					setProductName(product.description)
				}
			} catch (error) {
				setProductName(bookingDetails.bookingCargoDetails.product)
				console.log(error.message)
			}
		})()
	}, [])

	const getPetsSum = (cages) => {
		let petList = cages.map((item) => {
			return item.pets.length
		})
		let sum = 0;
		for (const item of petList) {
			sum += item;
		}
		if (sum > 1) {
			return sum + ' Pets';
		}
		else {
			return sum + ' Pet';
		}
	}

	const getCageString = (length) => {
		let cageString = length > 1 ? 'Containers' : 'Container'
		return cageString;
	}

	return (
		<div id='cargo-details' className='cargo-details-wrapper mt-1'>
			<div className='cargo-details-card-custom'>
				<div className='cargo-details-row responsive-cargo-row'>
					{/* First row: first four data items */}
					{/* <div className='cargo-details-col'>
						<div className='cargo-details-heading'>
							{bookingDetails.bookingCargoDetails.product === "LiveAnimals" ? t('COMMON.QTY') : t('COMMON.PCS')}
						</div>
						<div className='cargo-details-data'>
							{bookingDetails.bookingCargoDetails.product === "LiveAnimals"
								? bookingDetails.crates && bookingDetails.crates[0]?.weight
									? `${getPetsSum(bookingDetails.crates)} in ${bookingDetails.crates.length} ${getCageString(bookingDetails.crates.length)}`
									: ''
								: cargoDetails.quantity}
						</div>
					</div> */}

					<div className='cargo-details-col'>
						<div className='cargo-details-heading'>{t('COMMON.PRD')}</div>
						<div className='cargo-details-data'>
							{(() => {
								const systemProductName = bookingDetails?.bookingCargoDetails?.product;
								if (systemProductName && Array.isArray(masterData?.productsMaster)) {
									const found = masterData.productsMaster.find(
										prod => prod.systemProductName === systemProductName
									);
									return found ? found.description : systemProductName;
								}
								return '--';
							})()}
						</div>
					</div>

					<div className='cargo-details-col'>
						<div className='cargo-details-heading'>{t('COMMON.COMMODITY')}</div>
						<div className='cargo-details-data'>
							{cargoDetails.commodity ? cargoDetails.commodity : '--'}
						</div>
					</div>

					<div className='cargo-details-col'>
						<div className='cargo-details-heading'>{t('COMMON.SCC')}</div>
						<div className='cargo-details-data'>
							{cargoDetails.shipmentScc
								? cargoDetails.shipmentScc.map((e) => e).join(", ")
								: '--'}
						</div>
					</div>

					<div className='cargo-details-col'>
						<div className='cargo-details-heading'>{t('COMMON.GROSS_WT')}</div>
						<div className='cargo-details-data'>
							{cargoDetails.grossWeight ? <>
								{cargoDetails.grossWeight}
								{getWeightUnit(bookingDetails.weightUnit)}</> : '--'}
						</div>
					</div>

				</div>
				<div className='cargo-details-row responsive-cargo-row'>
					{/* Second row: next four data items */}
					<div className='cargo-details-col fixed-col-width'>
						<div className='cargo-details-heading'>{t('COMMON.VOL')}</div>
						<div className='cargo-details-data'>
							{cargoDetails?.volume ? <>{cargoDetails.volume}
								{getVolumeUnit(bookingDetails.volumeUnit)}</> : '--'}
						</div>
					</div>
					<div className='cargo-details-col fixed-col-width'>
						<div className='cargo-details-heading'>{t('COMMON.DENSITY')}</div>
						<div className='cargo-details-data'>
							{cargoDetails.density
								? <>
									{cargoDetails.density}
									{getDensityUnit(bookingDetails.weightUnit, bookingDetails.volumeUnit)}
								</>
								: '--'}
						</div>
					</div>

					{/* <div className='cargo-details-col'>
						<div className='cargo-details-heading'>{t('COMMON.SERVICE')}</div>
						<div className='cargo-details-data'>
							{cargoDetails.service ? cargoDetails.service : '--'}
						</div>
					</div> */}

				</div>
				{/* UNID Summary row if applicable */}
				{(
					bookingDetails.bookingCargoDetails.product !== "LiveAnimals" &&
					Array.isArray(bookingDetails?.dangerousGoodsInformation) && bookingDetails.dangerousGoodsInformation.length > 0 ||
					bookingDetails.bookingCargoDetails.product !== "LiveAnimals" && dgCheckNormal === 'false' &&
					Array.isArray(bookingDetails?.dangerousGoodsInformation) && bookingDetails.dangerousGoodsInformation.length > 0) && (
						<div className='cargo-details-row'>
							<div className='cargo-details-col'>
								<div className='cargo-details-heading'>{t('COMMON.UNIDSUMMARY')}</div>
										<div className='cargo-details-data'>
											{bookingDetails && bookingDetails?.additionalCommodityDetails && Array.isArray(bookingDetails.additionalCommodityDetails.dangerousGoods)
												? bookingDetails.additionalCommodityDetails.dangerousGoods.map((e, index) =>
													bookingDetails.additionalCommodityDetails.dangerousGoods.length - 1 === index ? `${e.unid}` : `${e.unid}, `
												)
												: '--'}
								</div>
							</div>
						</div>
					)}

				{/* Add WeightDetails section */}
				<WeightDetails bookingDetails={bookingDetails} />
			</div>
		</div>
	)
}

export default CargoDetails
